// Origins allowed as absolute return-url targets (e.g. LIS-Presta once it
// integrates with this central auth). Empty today: no external app is wired
// up yet, so only relative internal paths are accepted.
const TRUSTED_RETURN_ORIGINS: string[] = [];

export const DEFAULT_RETURN_PATH = '/';
export const RETURN_URL_PARAM = 'returnUrl';

const isSafeRelativePath = (value: string): boolean =>
  value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\');

export const getSafeReturnUrl = (rawValue: string | null | undefined): string => {
  if (!rawValue) return DEFAULT_RETURN_PATH;

  if (isSafeRelativePath(rawValue)) return rawValue;

  try {
    const parsed = new URL(rawValue);
    if (TRUSTED_RETURN_ORIGINS.includes(parsed.origin)) return parsed.toString();
  } catch {
    // Not a parseable absolute URL either; fall through to the safe default.
  }

  return DEFAULT_RETURN_PATH;
};

export const getReturnUrlFromSearch = (search: string): string =>
  getSafeReturnUrl(new URLSearchParams(search).get(RETURN_URL_PARAM));

export const withReturnUrl = (path: string, returnUrl: string): string =>
  returnUrl === DEFAULT_RETURN_PATH ? path : `${path}?${RETURN_URL_PARAM}=${encodeURIComponent(returnUrl)}`;
